<template lang="pug">
section.content
  vs-notify(group='general' position='top right' :duration='3000')
  Sidebar(:expanded="expanded")
  main.vl-parent#content
    LiveUpdates.liveUpdates
    router-view
</template>

<script>
import LiveUpdates from "Components/LiveUpdates.vue";
import Sidebar from "Dashboard/components/Sidebar/Index.vue";

import "./scss";

export default {
  name: "Content",
  components: {
    LiveUpdates,
    Sidebar,
  },
  props: {
    expanded: {
      type: Boolean,
    },
  },
};
</script>
